// extracted by css-extract-rspack-plugin
export default {"row":"cwxqnX2G2jwQBTDN"};